module.exports = __webpack_public_path__ + "static/media/hero-video-720p.dca5ec6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/content/homepage/images/hero-video-720p.mp4
// module id = Hn6a
// module chunks = 1